import React from 'react';

interface FeedbackTextAreaProps extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string;
  error?: string;
}

/** Labeled textarea with an optional validation message (Tailwind). */
const FeedbackTextArea = React.forwardRef<
  HTMLTextAreaElement,
  FeedbackTextAreaProps
>(({ label, error, className, ...rest }, ref) => (
  <div>
    {label && (
      <label className='mb-2! block headline-140 text-(--ayvens-theme-brand-secondary-400)'>
        {label}
      </label>
    )}
    <textarea
      ref={ref}
      rows={4}
      className={`w-full resize-none rounded-md border px-4! py-3! text-sm! transition-colors outline-none ${
        error
          ? 'border-red-500! focus:border-red-500!'
          : 'border-gray-300 focus:border-(--vel-color-primary-400)'
      } ${className ?? ''}`}
      {...rest}
    />
    {error && <p className='mt-1! text-xs! text-red-500!'>{error}</p>}
  </div>
));

FeedbackTextArea.displayName = 'FeedbackTextArea';

export default FeedbackTextArea;
